import { Link, useParams } from 'react-router-dom';
import DocsSidebar from '../components/DocsSidebar';
import DocBody from '../components/DocBody';
import { getDoc } from '../content/docs';

export default function DocPage() {
  const params = useParams();
  const slug = (params['*'] ?? '').replace(/\/+$/, '');
  const doc = getDoc(slug);

  return (
    <div className="docs-layout">
      <DocsSidebar activeSlug={slug} />
      <article className="doc-content">
        <nav className="breadcrumb" aria-label="Breadcrumb">
          <Link to="/docs">Documentation</Link>
          <span aria-hidden="true"> / </span>
          {doc ? <span>{doc.groupLabel}</span> : <span>Not found</span>}
        </nav>
        {doc ? (
          <DocBody doc={doc} />
        ) : (
          <>
            <h2>Document not found</h2>
            <p>
              No document exists at <code>/docs/{slug}</code>. Run{' '}
              <code>npm run prepare-docs</code> to refresh content from{' '}
              <code>../docs/</code>.
            </p>
          </>
        )}
      </article>
    </div>
  );
}
